// Direct Competitors Data
export const directCompetitors = [
  {
    id: 'contactswing',
    name: 'ContactSwing',
    website: 'contactswing.ai',
    pricing: 'Custom/Enterprise',
    pricingDetails: 'Custom pricing based on call volume and workspace requirements. API access included in business tiers.',
    features: ['24/7 AI Agents', 'Lead Qualification', 'Cal.com Integration', 'CRM Sync', 'SIP/API Access'],
    summary: 'Platform mirroring VoiceHub\'s posture: always-on AI calling + qualification + scheduling + broad integrations. Developer-facing with API docs and SIP-based integrations.',
    telephony: true,
    scheduling: true,
    api: true,
    relevance: 'High',
    comparison: {
      similar: ['24/7 AI voice agents', 'Lead qualification workflows', 'Cal.com scheduling integration', 'CRM synchronization (HubSpot, Zoho)', 'API access & SIP integration', 'Inbound/outbound call automation'],
      extra: ['Transparent startup-friendly pricing', 'Pre-built industry templates', 'Advanced call analytics dashboard', 'Real-time call monitoring'],
      missing: ['Two-layer multi-tenancy (Workspaces + White-label)', 'Native SMS/email template automation', 'Custom domain white-label instances', 'Workspace-level data isolation']
    }
  },
  {
    id: 'goodcall',
    name: 'Goodcall',
    website: 'goodcall.com',
    pricing: '$49/mo+',
    pricingDetails: 'Starter plans from $49/month. WooCommerce integration available. Zapier automation included in higher tiers.',
    features: ['AI Phone Agent', 'Lead Capture', 'Zapier Automation', 'CRM Updates', 'Calendar Connectivity'],
    summary: 'General-purpose AI phone agent platform connecting calls to CRMs/calendars and automations—similar outcomes to VoiceHub\'s assistants + templates + webhooks/Zapier positioning.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'High',
    comparison: {
      similar: ['AI phone agent automation', 'Lead capture & qualification', 'Zapier automation integration', 'CRM connectivity', 'Calendar booking support', 'Call routing & transfer'],
      extra: ['Transparent entry-level pricing ($49/mo)', 'WooCommerce native integration', 'Simple no-code setup', 'Small business focused UX'],
      missing: ['White-label capabilities', 'Multi-workspace client separation', 'Native SMS/email template system', 'SIP/API developer access', 'Custom domain branding']
    }
  },
  {
    id: 'newo',
    name: 'Newo',
    website: 'newo.ai',
    pricing: 'Custom',
    pricingDetails: 'Enterprise/agency-focused pricing. White-labeling and custom integrations available at higher tiers.',
    features: ['AI Receptionist', '24/7 Booking', 'API & Documentation', 'White-labeling', 'Custom Integrations'],
    summary: 'Overlaps on "answer calls + book appointments + integrate + resell/operate at scale" jobs-to-be-done. Strong alternative particularly in services-heavy SMB deployments.',
    telephony: true,
    scheduling: true,
    api: true,
    relevance: 'High',
    comparison: {
      similar: ['AI receptionist 24/7', 'Appointment booking automation', 'API access & documentation', 'White-labeling capabilities', 'Custom integrations', 'Outbound campaign support'],
      extra: ['HVAC/Plumbing vertical specialization', 'FSM (Field Service Management) integrations', 'Emergency escalation protocols', 'Trade-specific training data'],
      missing: ['Two-layer multi-tenancy (Workspaces + White-label)', 'Native SMS/email template workflows', 'Cal.com integration (uses proprietary scheduling)', 'Dynamic personalization variables']
    }
  },
  {
    id: 'voicegenie',
    name: 'VoiceGenie',
    website: 'voicegenie.ai',
    pricing: '$29/mo+',
    pricingDetails: 'Starting at $29/month for basic scheduling agent. Cal.com and Google Calendar sync included.',
    features: ['Cal.com Scheduling', 'Google Calendar Sync', 'SMS Reminders', 'Call Transfer', 'Reschedule Links'],
    summary: 'Competitively overlaps with VoiceHub\'s "Cal.com scheduling + voice agent + transfer + follow-up" cluster, though more narrowly packaged around scheduling use cases.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Cal.com scheduling integration', 'Google Calendar sync', 'Call transfer to human agents', 'SMS reminders & follow-ups', 'Reschedule link generation'],
      extra: ['Transparent low entry pricing ($29/mo)', 'Focused scheduling-only UX', 'Simple setup for small businesses'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'Outbound campaign management', 'Lead qualification workflows', 'API/developer access', 'Dynamic personalization', 'Email template automation']
    }
  },
  {
    id: 'consio',
    name: 'Consio',
    website: 'apps.shopify.com/consio',
    pricing: '$99/mo+',
    pricingDetails: 'Shopify App Store pricing. Typically $99-299/month based on call volume. No API access documented.',
    features: ['Inbound AI Voice', 'AI IVR', 'Outbound Power Dialer', 'Shopify Context Routing', 'ROI Tracking'],
    summary: 'Competes in commerce contexts as a Shopify-embedded alternative to configuring VoiceHub for e-commerce phone support + outreach campaigns.',
    telephony: true,
    scheduling: false,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Inbound AI voice answering', 'Outbound power dialer campaigns', 'AI IVR navigation', 'Call routing & context handling'],
      extra: ['Native Shopify integration', 'Store context routing (orders, inventory)', 'E-commerce ROI tracking', 'WISMO (Where Is My Order) automation', 'Shopify App Store distribution'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com scheduling integration', 'SMS/email template system', 'Dynamic personalization', 'Custom domain branding']
    }
  },
  {
    id: 'ava-ai',
    name: 'Ava AI',
    website: 'apps.shopify.com/ava-ai',
    pricing: '$79/mo+',
    pricingDetails: 'Shopify-native pricing tiers. Multi-call handling and order updates included. Dedicated phone number provided.',
    features: ['AI Phone Support', 'Multi-call Handling', 'Order Updates', 'Brand Voice Config', 'Dedicated Number'],
    summary: 'Competes as a Shopify-native "AI call center for your store," substituting for VoiceHub where the buyer wants immediate Shopify embedding and store-operations actions.',
    telephony: true,
    scheduling: false,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['AI phone support automation', 'Multi-call handling capability', 'Dedicated phone number provisioning', 'Call recording & transcripts', 'Brand voice configuration'],
      extra: ['Native Shopify App Store integration', 'Real-time order status updates', 'Store operations context awareness', 'Multi-call concurrency (handle multiple callers)', 'Shopify-specific workflows'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Scheduling/appointment booking', 'Outbound campaigns', 'SMS/email template automation', 'Cal.com integration', 'Dynamic personalization']
    }
  },
  {
    id: 'ringly',
    name: 'Ringly.io',
    website: 'ringly.io',
    pricing: '$59/mo+',
    pricingDetails: 'Starts at $59/month for Shopify brands. API, webhooks, and Twilio integration available in higher tiers.',
    features: ['AI Phone Support', 'Order Lookup', 'Helpdesk Escalation', 'Call Recordings', 'API/Webhooks'],
    summary: 'Overlaps on "AI answers calls + call transfer + call logs + integration hooks," but positioned primarily as Shopify support automation rather than a full campaigns + scheduling suite.',
    telephony: true,
    scheduling: false,
    api: true,
    relevance: 'Medium',
    comparison: {
      similar: ['AI phone support', 'Call recordings & transcripts', 'Helpdesk escalation/transfer', 'API & webhook access', 'Twilio integration', 'Order lookup capabilities'],
      extra: ['Shopify-native integration', 'E-commerce order context awareness', 'Helpdesk platform integrations', 'Lower entry pricing ($59/mo)'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'Appointment scheduling', 'Cal.com integration', 'Outbound campaigns', 'Native SMS/email templates', 'Dynamic personalization', 'Custom domain branding']
    }
  },
  {
    id: 'servicetitan',
    name: 'ServiceTitan AI Voice',
    website: 'servicetitan.com',
    pricing: 'Custom/FSM Bundle',
    pricingDetails: 'Bundled with ServiceTitan FSM platform. Custom pricing based on field service management package.',
    features: ['Trade Workflows', '24/7 Call Coverage', 'Job Booking', 'Rescheduling', 'Contact Center'],
    summary: 'Vertical substitute in home services—buyers may choose an integrated FSM + AI voice agent rather than deploying VoiceHub as a separate calling layer.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['24/7 AI call coverage', 'Job booking & scheduling', 'Call rescheduling capabilities', 'Contact center features', 'Call transfer/escalation'],
      extra: ['Integrated FSM (Field Service Management) platform', 'Trade-specific workflows (HVAC, plumbing, electrical)', 'Native technician dispatching', 'Job management integration', 'Revenue tracking & reporting', 'Marketing attribution'],
      missing: ['White-label capabilities', 'Multi-workspace client separation', 'API access', 'Cal.com integration (uses internal scheduler)', 'SMS/email template automation', 'Dynamic personalization', 'Custom domain branding', 'Standalone deployment (requires ServiceTitan)']
    }
  },
  {
    id: 'housecall-pro',
    name: 'Housecall Pro CSR AI',
    website: 'housecallpro.com',
    pricing: 'Add-on to FSM',
    pricingDetails: 'Available as add-on to Housecall Pro subscription. Pricing varies by plan tier.',
    features: ['24/7 Call Answering', 'Automated Booking', 'Out-of-hours Support', 'Call Transfer', 'Audit Trail'],
    summary: 'Competes as an integrated operational stack for trades—overlap is strongest on after-hours answering, scheduling, and escalation workflows.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['24/7 call answering', 'Automated job booking', 'Out-of-hours support coverage', 'Call transfer to humans', 'Call summaries & audit trail'],
      extra: ['Integrated with Housecall Pro FSM', 'Trade-specific workflow automation', 'Native technician scheduling', 'Customer portal integration', 'Payment processing integration'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration', 'Outbound campaigns', 'SMS/email template system', 'Dynamic personalization', 'Standalone usage (requires Housecall Pro subscription)']
    }
  },
  {
    id: 'toma',
    name: 'Toma',
    website: 'toma.com',
    pricing: 'Custom/Dealer',
    pricingDetails: 'Dealership-specific pricing. Service scheduling and DMS integration included.',
    features: ['Full-store Receptionist', 'Service Scheduling', 'DMS Integration', 'Automated Reminders', 'Dealer-specific Training'],
    summary: 'Dealership-specialized substitute for VoiceHub in automotive service scheduling and receptionist workflows.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Full-store AI receptionist', 'Service scheduling automation', 'Automated reminders (calls & texts)', 'Call transfer/escalation', '24/7 call handling'],
      extra: ['DMS (Dealer Management System) integration', 'Dealership-specific AI training', 'Automotive industry expertise', 'Parts department integration', 'Service bay optimization', 'OEM-specific workflows'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration (uses DMS scheduling)', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Horizontal industry support (auto-only)']
    }
  },
  {
    id: 'pam',
    name: 'Pam',
    website: 'pam.ai',
    pricing: 'Custom/Enterprise',
    pricingDetails: 'Enterprise pricing for dealership groups. Outbound campaigns and retention flows included.',
    features: ['Outbound Campaigns', 'Service Booking', 'Recall/Retention', '24/7 Voice AI', 'Multi-channel Nurturing'],
    summary: 'Competes most strongly where VoiceHub is used for outbound campaigns + automated scheduling in automotive operations (service retention/recall flows).',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Outbound campaign automation', 'Service booking integration', '24/7 voice AI coverage', 'Multi-channel nurturing (voice + SMS)', 'Call transfer/escalation'],
      extra: ['Dealership group focus', 'Recall campaign automation', 'Service retention workflows', 'DMS integration', 'BDC (Business Development Center) optimization', 'Equity mining capabilities'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Horizontal industry support (auto-only)']
    }
  },
  {
    id: 'slang-ai',
    name: 'Slang AI',
    website: 'slang.ai',
    pricing: '$149/mo+',
    pricingDetails: 'Restaurant-focused pricing. OpenTable integration included. Volume-based tiers available.',
    features: ['High-volume Call Handling', 'OpenTable Integration', 'Reservation Management', '24/7 Coverage', 'Phone Number Management'],
    summary: 'Vertical competitor for restaurants; VoiceHub can be configured for similar receptionist + booking outcomes, but Slang is purpose-built for restaurant reservation call flows.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['High-volume call handling', 'Reservation management', '24/7 coverage', 'Phone number management', 'Call transfer capabilities'],
      extra: ['OpenTable native integration', 'Restaurant-specific training', 'Waitlist management', 'Table optimization', 'Reservation modification/cancellation', 'Multi-location support', 'Volume-based pricing for high-call restaurants'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration (uses OpenTable)', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Outbound campaigns', 'Lead qualification', 'Horizontal industry support (restaurant-only)']
    }
  },
  {
    id: 'yelp-host',
    name: 'Yelp Host',
    website: 'yelp-ir.com',
    pricing: 'Yelp Premium+',
    pricingDetails: 'Included in Yelp for Business premium tiers. Guest Manager integration required.',
    features: ['Reservation Management', 'Waitlist Handling', 'SMS Follow-ups', 'Spam Filtering', 'Yelp Guest Manager'],
    summary: 'Competes as a restaurant-first AI answering + reservation management layer where VoiceHub could otherwise be deployed as the call automation and booking system.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Reservation management', 'Waitlist handling', 'SMS follow-ups', 'Call answering/triage', 'Spam filtering'],
      extra: ['Yelp Guest Manager integration', 'Yelp ecosystem integration', 'Review platform connectivity', 'Local discovery optimization', 'Bundled with Yelp Business subscription'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Outbound campaigns', 'Lead qualification', 'Standalone deployment (requires Yelp subscription)']
    }
  },
  {
    id: 'yelp-receptionist',
    name: 'Yelp Receptionist',
    website: 'yelp-ir.com',
    pricing: 'Yelp Business+',
    pricingDetails: 'Available as part of Yelp for Business premium packages. Local service focus.',
    features: ['Call Triage', 'Lead Intake', 'Call Recordings', 'Transcripts', 'Spam Filtering'],
    summary: 'Overlaps with VoiceHub\'s "AI receptionist + lead qualification + call logs" cluster, targeting local-service businesses.',
    telephony: true,
    scheduling: false,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['AI receptionist/call triage', 'Lead intake & qualification', 'Call recordings', 'Call transcripts', 'Spam filtering'],
      extra: ['Yelp for Business integration', 'Local service business focus', 'Yelp inbox delivery', 'Bundled with Yelp premium', 'Review generation support'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Scheduling/appointment booking', 'Cal.com integration', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Outbound campaigns', 'Standalone deployment (requires Yelp subscription)']
    }
  },
  {
    id: 'huskyvoice',
    name: 'HuskyVoice.AI',
    website: 'huskyvoice.ai',
    pricing: '$199/mo+',
    pricingDetails: 'HIPAA-compliant tiers starting at $199/month. EHR integrations included in medical packages.',
    features: ['HIPAA Compliant', '24/7 Patient Calls', 'EHR Integration', 'Appointment Scheduling', 'Emergency Routing'],
    summary: 'Competes as a healthcare-first AI receptionist stack; VoiceHub overlaps functionally via telephony + scheduling + transfer + integrations, but HuskyVoice is positioned specifically around clinical compliance and EHR-centric workflows.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['HIPAA compliance', '24/7 patient call handling', 'Appointment scheduling', 'Emergency call routing', 'Call transfer/escalation'],
      extra: ['EHR system integrations (Epic, Cerner, etc.)', 'Healthcare-specific AI training', 'Clinical workflow expertise', 'Patient portal integration', 'Insurance verification support', 'Medical terminology recognition', 'BAA (Business Associate Agreement) included'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'API access', 'Cal.com integration (uses EHR scheduling)', 'Email template automation', 'Dynamic personalization', 'Custom domain branding', 'Outbound campaigns', 'Horizontal industry support (healthcare-only)']
    }
  },
  {
    id: 'polyai',
    name: 'PolyAI',
    website: 'poly.ai',
    pricing: 'Enterprise Only',
    pricingDetails: 'Enterprise contact center pricing. Custom contracts based on call volume and resolution targets.',
    features: ['Voice + Chat + SMS', 'Contact Center Scale', 'Natural Speech Understanding', 'Call Resolution', 'Enterprise Deployment'],
    summary: 'Competes most in larger-scale enterprise contact-center deployments where VoiceHub might be used for call automation, though packaging and buyer segment may differ.',
    telephony: true,
    scheduling: false,
    api: false,
    relevance: 'Low',
    comparison: {
      similar: ['Voice + Chat + SMS omnichannel', 'Enterprise-scale deployment', 'Natural speech understanding', 'Call resolution automation', 'Contact center integration'],
      extra: ['Managed service approach (custom builds)', '750ms latency guarantee', 'Supervised learning optimization', 'Enterprise SLA ($150K+ annual)', 'Advanced NLU capabilities', 'Custom voice design', 'Proactive conversation improvement'],
      missing: ['White-label capabilities', 'Two-layer multi-tenancy', 'Transparent pricing', 'Cal.com integration', 'Native SMS/email templates', 'Dynamic personalization', 'Self-service platform (managed only)', 'SMB/Agency pricing tiers']
    }
  },
  {
    id: 'replicant',
    name: 'Replicant',
    website: 'replicant.com',
    pricing: 'Enterprise/Custom',
    pricingDetails: 'Enterprise pricing model. Focus on autonomous call resolution and contact center automation.',
    features: ['Voice Automation', 'Appointment Scheduling', 'Outbound Reminders', 'Call Routing', 'Multilingual'],
    summary: 'Overlaps strongly on enterprise call automation + scheduling/reminder workflows; it competes where VoiceHub is evaluated for call-center-scale automation rather than SMB/agency deployments.',
    telephony: true,
    scheduling: true,
    api: false,
    relevance: 'Medium',
    comparison: {
      similar: ['Voice automation platform', 'Appointment scheduling', 'Outbound reminder campaigns', 'Call routing & escalation', 'Multilingual support', 'Autonomous call resolution'],
      extra: ['Thinking Machine™ AI engine', 'Auto-pilot call resolution', 'Enterprise contact center focus', 'Advanced analytics & insights', 'Agent assist capabilities', 'Custom integration development'],
      missing: ['White-label capabilities', 'Multi-workspace architecture', 'Transparent pricing', 'Cal.com integration (custom scheduling)', 'Native SMS/email templates', 'Dynamic personalization', 'SMB/Agency self-service', 'Custom domain branding']
    }
  },
  {
    id: 'cognigy',
    name: 'Cognigy',
    website: 'cognigy.com',
    pricing: 'Enterprise/Custom',
    pricingDetails: 'Enterprise conversational AI platform pricing. Contact center transformation focus.',
    features: ['Phone Experiences', 'Conversational Routing', 'IVR Replacement', '24/7 Self-service', 'Contextual Handoff'],
    summary: 'Competes in contact-center transformation initiatives. The overlap lies in phone conversation automation and routing/handoff; VoiceHub\'s differentiator is its simpler "numbers + campaigns + scheduling + white label" operational suite.',
    telephony: true,
    scheduling: false,
    api: false,
    relevance: 'Low',
    comparison: {
      similar: ['Phone experience automation', 'Conversational routing', 'IVR replacement', '24/7 self-service', 'Contextual handoff to agents'],
      extra: ['Visual flow builder (low-code)', 'Cognigy Insights (analytics)', 'Agent + AI hybrid model', 'Extensive pre-built integrations', 'Enterprise security & compliance', 'Multi-bot orchestration', 'Voice + digital channel unification'],
      missing: ['White-label capabilities', 'Two-layer multi-tenancy', 'Transparent pricing', 'Cal.com integration', 'Native SMS/email templates', 'Dynamic personalization', 'SMB/Agency focus', 'Custom domain branding', 'Appointment scheduling module']
    }
  },
  {
    id: 'five9',
    name: 'Five9 IVA',
    website: 'five9.com',
    pricing: 'CCaaS Bundle',
    pricingDetails: 'Bundled with Five9 CCaaS platform. Enterprise contact center pricing.',
    features: ['IVA Deployment', 'Voice/Chat/SMS', 'Appointment Automation', 'APIs & SDKs', 'Live Agent Handoff'],
    summary: 'Competes when the buyer wants a full CCaaS + IVA stack (enterprise). Overlap is clear on voice automation, appointment-taking, and agent handoff.',
    telephony: true,
    scheduling: true,
    api: true,
    relevance: 'Low',
    comparison: {
      similar: ['IVA (Intelligent Virtual Agent) deployment', 'Voice/Chat/SMS omnichannel', 'Appointment automation', 'APIs & SDKs', 'Live agent handoff'],
      extra: ['Full CCaaS platform integration', 'Workforce optimization (WFO)', 'Quality management', 'Predictive dialer', 'CRM integrations (Salesforce, MS Dynamics)', 'Enterprise-grade reliability', 'Advanced call distribution (ACD)'],
      missing: ['White-label capabilities', 'Two-layer multi-tenancy', 'Transparent pricing', 'Cal.com integration (uses internal scheduler)', 'Native SMS/email templates', 'Dynamic personalization', 'SMB/Agency self-service', 'Custom domain branding', 'Standalone IVA (requires CCaaS bundle)']
    }
  },
  {
    id: 'google-cloud',
    name: 'Google Cloud CCAI',
    website: 'cloud.google.com',
    pricing: 'Usage-based',
    pricingDetails: 'Pay-per-use pricing for virtual agents. Additional costs for Dialogflow CX and telephony integration.',
    features: ['Virtual Agents', 'SIP Integration', 'Generative AI', 'Escalation Flows', 'Custom Voice'],
    summary: 'Competes as a programmable enterprise alternative for "voice agents on phone lines," but is typically an infrastructure + engineering implementation rather than a ready-to-run SaaS calling suite like VoiceHub.',
    telephony: true,
    scheduling: false,
    api: true,
    relevance: 'Low',
    comparison: {
      similar: ['Virtual agent platform', 'SIP telephony integration', 'Generative AI capabilities', 'Escalation flow design', 'Custom voice/TTS options'],
      extra: ['Google AI/ML infrastructure', 'Dialogflow CX visual builder', 'Multi-language NLU (30+ languages)', 'Enterprise security (Google Cloud)', 'Usage-based pricing transparency', 'Integration with Google Workspace', 'Advanced analytics & insights'],
      missing: ['White-label capabilities', 'Two-layer multi-tenancy', 'Ready-to-run SaaS (requires build)', 'Cal.com integration (custom build required)', 'Native SMS/email templates (custom build)', 'Dynamic personalization (custom build)', 'SMB/Agency self-service', 'Custom domain branding', 'Appointment scheduling (custom build)', 'Phone number management (via third-party)']
    }
  }
];

// Industry Categories Data
export const categories = [
  {
    id: 'ecommerce',
    name: 'E-commerce & Retail',
    apps: [
      {
        id: 'loop-voice',
        name: 'Loop Voice',
        website: 'apps.shopify.com/loop-voice-agent',
        pricing: '$49/mo+',
        pricingDetails: 'Revenue-based pricing. Charges based on recovered cart value percentage plus base fee.',
        industry: 'E-commerce (Shopify)',
        features: ['Abandoned Cart Recovery', 'Upsell Flows', 'Real-time Analytics', 'Shopify Data Context'],
        summary: 'Targets revenue workflows—especially cart recovery—using AI call agents that reference cart and order details in conversation.'
      },
      {
        id: 'callsy',
        name: 'Callsy',
        website: 'apps.shopify.com/callsy-ai',
        pricing: '$39/mo+',
        pricingDetails: 'Tiered pricing based on call volume. Personalized discount features included in all plans.',
        industry: 'E-commerce (Shopify)',
        features: ['Abandoned Checkout Calls', 'Personalized Discounts', 'Transcripts', 'Post-call SMS', 'Multilingual'],
        summary: 'Automates outbound calls to shoppers who abandoned checkout and positions the agent as an objection-handler that can offer discounts and drive conversion.'
      },
      {
        id: 'kovax',
        name: 'Kovax',
        website: 'apps.shopify.com/webrex-voice-ai-agent',
        pricing: '$69/mo+',
        pricingDetails: 'Inbound + outbound bundles. WISMO reduction focus with multi-channel follow-up included.',
        industry: 'E-commerce (Shopify)',
        features: ['Inbound + Outbound', 'WISMO Reduction', 'Voicemail + Routing', 'Multi-channel Follow-up'],
        summary: 'Emphasizes automating both inbound and outbound calls for common e-commerce scenarios: order questions, shipping/policy inquiries, and recovery flows.'
      },
      {
        id: 'nlpearl',
        name: 'NLPearl AI',
        website: 'apps.shopify.com/nlpearl',
        pricing: '$59/mo+',
        pricingDetails: 'Commerce-trained agent pricing. Upsells and cart recovery included in standard tiers.',
        industry: 'E-commerce (Shopify)',
        features: ['24/7 Voice Agent', 'Order Tracking', 'Multilingual', 'Upsells', 'Sentiment Analysis'],
        summary: 'Presents a commerce-trained phone agent that can answer customer calls, track orders, and drive sales outcomes like upsells and cart recovery.'
      },
      {
        id: 'unicall',
        name: 'Unicall.ai',
        website: 'apps.shopify.com/unicall-ai',
        pricing: '$45/mo+',
        pricingDetails: 'Dedicated number included. Returns and refunds support available in higher tiers.',
        industry: 'E-commerce (Shopify)',
        features: ['AI Call Handling', 'Dedicated Number', 'Order Sync', 'Returns Support', 'Escalation'],
        summary: 'Positioned as a Shopify-synced phone support agent that can resolve routine inquiries like tracking, returns, and discount/payment issues.'
      },
      {
        id: 'vinsi-ai',
        name: 'Vinsi AI',
        website: 'apps.shopify.com/ai-phone-agent-vinsi-ai',
        pricing: '$35/mo+',
        pricingDetails: 'Unlimited call handling on all plans. Analytics and recordings included.',
        industry: 'E-commerce (Shopify)',
        features: ['24/7 AI Agent', 'Order Status', 'Product Details', 'Call Analytics', 'Unlimited Calls'],
        summary: 'Centers on a dedicated phone number for customer calls, with the AI handling routine questions like order status and product information.'
      }
    ]
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Clinics',
    apps: [
      {
        id: 'medical-office-force',
        name: 'Medical Office Force',
        website: 'medicalofficeforce.com',
        pricing: 'Custom',
        pricingDetails: 'Clinic-specific pricing. Demo numbers available for live call experience.',
        industry: 'Healthcare',
        features: ['AI Virtual Receptionist', 'Appointment Scheduling', 'Demo Numbers', 'Front-desk Automation'],
        summary: 'Publishes an "AI Virtual Receptionist for Healthcare Clinics" concept focused on answering calls and scheduling appointments without long holds.'
      },
      {
        id: 'curemd',
        name: 'CureMD',
        website: 'curemd.com',
        pricing: 'EHR Bundle',
        pricingDetails: 'Bundled with CureMD EHR system. Virtual receptionist add-on available.',
        industry: 'Healthcare',
        features: ['Virtual Receptionist', '24/7 Scheduling', 'Patient Intake', 'Refills', 'Payments'],
        summary: 'Markets a "Virtual Medical Receptionist" designed to automate common front-desk functions around the clock including scheduling, intake, refills, and payments.'
      },
      {
        id: 'aeva-ai',
        name: 'Aeva AI',
        website: 'aevaai.com',
        pricing: 'Custom',
        pricingDetails: 'Per-clinic pricing model. Always-on availability positioning.',
        industry: 'Healthcare',
        features: ['Patient Call Handling', 'Appointment Booking', 'Clinic Enquiries', '24/7 Availability'],
        summary: 'Frames its product as an AI receptionist for clinics that can answer patient calls consistently while booking appointments and handling common inquiries.'
      },
      {
        id: 'keona-health',
        name: 'Keona Health',
        website: 'keonahealth.com',
        pricing: 'Custom',
        pricingDetails: 'CareDesk AI Agent pricing based on patient volume. Scheduling logic included.',
        industry: 'Healthcare',
        features: ['AI Call Agent', '24/7 Operation', 'Scheduling Logic', 'Context Handoff'],
        summary: 'Describes its CareDesk AI Agent ("Kara") as an always-on patient access assistant that understands schedules and scheduling logic.'
      }
    ]
  },
  {
    id: 'realestate',
    name: 'Real Estate',
    apps: [
      {
        id: 'ai-receptionist-re',
        name: 'AI Receptionist',
        website: 'aireceptionistrealestate.com',
        pricing: 'Custom',
        pricingDetails: 'Real estate professional focused. Phone and text conversation bundles.',
        industry: 'Real Estate',
        features: ['Phone + Text Automation', 'Front Desk AI', 'Inquiry Capture', 'Real Estate Focused'],
        summary: 'Markets itself as a platform built specifically for real estate professionals to automate conversations, including phone interactions.'
      },
      {
        id: 'voqo',
        name: 'Voqo',
        website: 'voqo.ai',
        pricing: 'Custom',
        pricingDetails: 'Same-day launch pricing. Workflow scenario customization included.',
        industry: 'Real Estate',
        features: ['24/7 Call Answering', 'Workflow Scenarios', 'Custom Training', 'Rapid Launch'],
        summary: 'Positions its voice AI as trained for real-estate workflows and available 24/7, aiming to engage prospects immediately.'
      },
      {
        id: 'voagents',
        name: 'VoAgents',
        website: 'voagents.ai',
        pricing: 'Custom',
        pricingDetails: 'Lead call automation pricing. CRM and marketing tool integration bundles.',
        industry: 'Real Estate',
        features: ['Inbound/Outbound Calls', 'Follow-up Automation', 'CRM Integration', 'Auto-dialer'],
        summary: 'Presents itself as a real-estate-focused AI voice agent and autodialer-like solution for handling lead calls without manual dialing.'
      }
    ]
  },
  {
    id: 'hospitality',
    name: 'Hospitality & Restaurants',
    apps: [
      {
        id: 'loman',
        name: 'Loman',
        website: 'loman.ai',
        pricing: 'OpenTable Partner',
        pricingDetails: 'Pricing through OpenTable partnership. Reservation management focused.',
        industry: 'Restaurants',
        features: ['24/7 AI Agent', 'OpenTable Integration', 'Reservation Management', 'Booking/Canceling'],
        summary: 'OpenTable lists Loman as a 24/7 AI phone agent that can book, manage, and cancel reservations in OpenTable for restaurant guests.'
      },
      {
        id: 'hostie-ai',
        name: 'Hostie AI',
        website: 'hostie.ai',
        pricing: 'Custom',
        pricingDetails: 'Virtual concierge pricing. Events and takeout workflow support included.',
        industry: 'Restaurants',
        features: ['Calls + Texts', 'Reservations', 'Events', 'Takeout', 'Virtual Concierge'],
        summary: 'OpenTable lists Hostie AI as a "virtual concierge" that covers calls and texts while also handling reservations, events, and takeout-related interactions.'
      },
      {
        id: 'canary-technologies',
        name: 'Canary Technologies',
        website: 'canarytechnologies.com',
        pricing: 'Hotel Chain Pricing',
        pricingDetails: 'Property-specific pricing. Hotel chain and brand standard training included.',
        industry: 'Hotels',
        features: ['Guest Call Handling', 'Booking Capture', 'Property-specific Training', 'Brand Standards'],
        summary: 'Positioned as a hospitality-focused inbound calling solution that answers guest questions and helps capture bookings so calls aren\'t missed.'
      }
    ]
  },
  {
    id: 'homeservices',
    name: 'Home Services & Automotive',
    apps: [
      {
        id: 'newo-hvac',
        name: 'Newo (HVAC/Plumbing)',
        website: 'newo.ai/hvac-plumbing-ai-receptionist',
        pricing: 'Custom',
        pricingDetails: 'Field service platform integration pricing. Emergency escalation protocols included.',
        industry: 'Home Services',
        features: ['Service Scheduling', 'FSM Integration', 'Emergency Detection', 'Escalation Protocols'],
        summary: 'Positions its home-services receptionist around direct integration with major field service management platforms, enabling the AI to book appointments directly.'
      },
      {
        id: 'serviceagent',
        name: 'ServiceAgent',
        website: 'serviceagent.ai',
        pricing: '$99/mo+',
        pricingDetails: 'Home service business pricing. 24/7 lead capture and calendar booking included.',
        industry: 'Home Services',
        features: ['24/7 Call Answering', 'Lead Qualification', 'Calendar Booking', 'Home Services Training'],
        summary: 'Frames itself as an AI call answering product designed specifically for home service businesses to prevent missed leads.'
      },
      {
        id: 'auralix-ai',
        name: 'Auralix AI',
        website: 'auralixai.ca',
        pricing: 'Enterprise',
        pricingDetails: 'Enterprise voice platform pricing. API-first integration with job management tools.',
        industry: 'Home Services',
        features: ['AI Receptionist', '24/7 Appointments', 'Job Management Integration', 'Enterprise API'],
        summary: 'Positions its voice product as a home-services-first AI receptionist designed to handle appointments, routine inquiries, and customer service calls.'
      },
      {
        id: 'dealer-surge',
        name: 'Dealer Surge AI',
        website: 'dealersurge.ai',
        pricing: 'Custom',
        pricingDetails: 'Dealership group pricing. Multi-channel nurturing (voice + SMS) bundles.',
        industry: 'Automotive',
        features: ['Lead Engagement', 'Appointment Booking', '24/7 Coverage', 'Multi-channel Nurturing'],
        summary: 'Positions its voice AI as a dealership-first agent to answer calls, engage inbound leads, and book appointments 24/7.'
      },
      {
        id: 'stella-automotive',
        name: 'STELLA Automotive AI',
        website: 'stellaautomotive.com',
        pricing: 'Custom',
        pricingDetails: 'Dealership engagement platform pricing. Always-on reception features.',
        industry: 'Automotive',
        features: ['Always-on Answering', 'Dealership Engagement', 'Front-desk Reception', '24/7 Availability'],
        summary: 'Presented as an automotive-focused engagement layer intended to power consistent customer interactions and reduce missed opportunities.'
      },
      {
        id: 'diago',
        name: 'Diago',
        website: 'diago.ai',
        pricing: 'Custom',
        pricingDetails: 'Car dealer/garage pricing. CRM synchronization and follow-up automation included.',
        industry: 'Automotive',
        features: ['24/7 Reception', 'Service Booking', 'CRM Sync', 'Automated Follow-ups'],
        summary: 'Positions itself as an AI voice agent for car dealerships and garages focused on never missing calls and automating appointment booking.'
      }
    ]
  },
  {
    id: 'callcenters',
    name: 'Call Centers & Enterprise',
    apps: [
      {
        id: 'floatbot',
        name: 'Floatbot',
        website: 'floatbot.ai',
        pricing: 'Enterprise',
        pricingDetails: 'Banking and financial services pricing. Inbound and outbound call automation.',
        industry: 'Finance/Banking',
        features: ['Banking Automation', 'Inbound/Outbound Calls', 'Reminders', 'Collections', '24/7 Support'],
        summary: 'Describes banking-focused automation that includes "smart Voice AI" for automating inbound and outbound calls, including reminders and collections.'
      },
      {
        id: 'kore-ai',
        name: 'Kore.ai',
        website: 'kore.ai',
        pricing: 'Enterprise',
        pricingDetails: 'Agentic AI platform pricing. Secure transaction and compliance modules extra.',
        industry: 'Finance/Banking',
        features: ['Banking AI Agents', '24/7 Self-service', 'Secure Transactions', 'Compliance', 'Human Handoff'],
        summary: 'Positions its banking solution as an agentic AI layer for customer self-service and operational workflows, including always-on support.'
      },
      {
        id: 'voicefleet',
        name: 'VoiceFleet',
        website: 'voicefleet.ai',
        pricing: '$149/mo+',
        pricingDetails: 'Insurance agency specific pricing. Quote request handling included.',
        industry: 'Insurance',
        features: ['Quote Requests', '24/7 Coverage', 'Receptionist Alternative', 'Cost Reduction'],
        summary: 'Markets AI voice agents specifically for insurance agencies with a focus on handling quote requests around the clock.'
      },
      {
        id: 'fluents',
        name: 'Fluents',
        website: 'fluents.ai',
        pricing: 'Custom',
        pricingDetails: 'High-volume insurance workflow pricing. Claims intake and renewal automation.',
        industry: 'Insurance',
        features: ['Quoting/Enrollment', 'Claims Intake', 'Renewals', '24/7 Inbound', 'CRM/AMS Connectivity'],
        summary: 'Positions its insurance voice agents around high-volume insurance workflows such as quoting, enrollment, claims intake, and renewals.'
      }
    ]
  },
  {
    id: 'education',
    name: 'Education',
    apps: [
      {
        id: 'botsense',
        name: 'Botsense',
        website: 'botsense.io',
        pricing: 'Institution-based',
        pricingDetails: 'Educational institution pricing. High-volume calling packages available.',
        industry: 'Education',
        features: ['Admission Inquiries', 'Fee Reminders', 'Student Follow-ups', 'High-volume Calling'],
        summary: 'Markets AI calling specifically for educational institutions, focusing on automating admissions inquiries and operational calls.'
      },
      {
        id: 'ringg-ai',
        name: 'Ringg AI',
        website: 'ringg.ai',
        pricing: 'EdTech Pricing',
        pricingDetails: 'EdTech platform integration pricing. Onboarding and retention focus.',
        industry: 'Education',
        features: ['Voice AI Agents', 'Onboarding Assistance', 'Inquiry Handling', 'Retention Automation'],
        summary: 'Positions its EdTech solution around automated, personalized voice support across onboarding and inquiry workflows.'
      },
      {
        id: 'cloudtalk-edu',
        name: 'CloudTalk (Education)',
        website: 'cloudtalk.io',
        pricing: 'Per-agent',
        pricingDetails: 'Per-agent pricing with education discounts. CRM/SIS integration included.',
        industry: 'Education',
        features: ['24/7 Inbound', 'Lead Qualification', 'Tour Booking', 'Multilingual', 'CRM Integration'],
        summary: 'Frames its education enrollment voice agent around responding instantly to prospective students, qualifying leads, and booking campus tours.'
      },
      {
        id: 'edysor',
        name: 'Edysor',
        website: 'edysor.ai',
        pricing: 'University Pricing',
        pricingDetails: 'University admissions team pricing. CRM integration and contextual handoff included.',
        industry: 'Education',
        features: ['CRM Integration', 'Query Answering', 'Lead Qualification', 'Contextual Handoff'],
        summary: 'Positions its voice agent as customized for university admissions teams, emphasizing CRM integration and context-rich handoffs.'
      },
      {
        id: 'aioncalls',
        name: 'AIOnCalls',
        website: 'aioncalls.com',
        pricing: 'Institution-based',
        pricingDetails: 'School/college/coaching pricing. Multilingual support included.',
        industry: 'Education',
        features: ['24/7 AI Agent', 'Admission Enquiries', 'Course FAQs', 'Counseling Booking', 'Multilingual'],
        summary: 'Markets AI calling software built specifically for educational institutions to automate admissions enquiries and routine FAQs.'
      }
    ]
  }
];
